import React from 'react';
import POPUP_STYLES from '../../constants/popup-styles';
import BasicDialog from '../../scenes/Dialog/components/BasicDialog';
import FormDialog from '../../scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from '../../scenes/Dialog/components/ResponseErrorDialog';
import UpgradeRecruiterAccount from '../../scenes/Dialog/components/UpgradeRecruiterAccount';
import CandidateSetRatingForm from '../../scenes/Form/components/CandidateSetRatingForm';
import CandidateSetTagForm from '../../scenes/Form/components/CandidateSetTagForm';
import {Permission, Role} from '../user';

export class SearchActions {
  constructor(api, user) {
    this.api = api;
    this.user = user;
  }

  rate = (candidate, processId = null) => {
    if (Role.isRecruiterDefault(this.user)) {
      UpgradeRecruiterAccount();
      return Promise.reject();
    }

    return FormDialog({
      title: 'Rate Profile',
      modeless: false,
      popupStyles: POPUP_STYLES.formPopupStyles,
      popupInnerStyles: POPUP_STYLES.formInnerStyles,
      popupTitleStyles: POPUP_STYLES.formTitleStyles,
      compact: true,
      params: {
        candidate,
        processId,
        disableForm: !Permission.isAllowedRateCandidates(this.user.permissions),
      },
      form: (actions, params) => (
        <CandidateSetRatingForm actions={actions} params={params} />
      ),
    }).then(data => data, response => ResponseErrorDialog({ response }));
  };

  tag = item =>
    new Promise(resolve =>
      FormDialog({
        title: 'Tag Profile',
        popupStyles: POPUP_STYLES.formPopupStyles,
        popupInnerStyles: POPUP_STYLES.formInnerStyles,
        popupTitleStyles: POPUP_STYLES.formTitleStyles,
        compact: true,
        modeless: false,
        params: { item },
        form: (actions, params) => (
          <CandidateSetTagForm actions={actions} params={params} />
        ),
      }).then(
        () => {
          BasicDialog({ bodyRender: 'Changes were successfully saved' });
          resolve();
        },
        response => ResponseErrorDialog({ response })
      )
    );
}
